/**
 * This function check if string is a scientific notation or normal number and verify if value is in min/max range.
 *
 * @param {string | number} value A string to check
 * @param {number | false} minLimit Minium value acceptable for number. Default is 0. | If false, validation is cancelled
 * @param {number | false} maxLimit Maximum value acceptable for number. Default is 1. | If false, validation is cancelled
 * @param {boolean} minCloseInterval defines if min limit is open or close interval, Default is false
 * @param {boolean} maxCloseInterval defines if max limit is open or close interval, Default is true
 * @returns {boolean} If value is valid and in range
 */
export function checkIsValidFrequencyRange(
    value: string | number,
    minLimit: number | false = 0,
    maxLimit: number | false = 1,
    minCloseInterval = false,
    maxCloseInterval = true
): boolean {
    if (value === null || value === undefined || value.toString().trim().length === 0) {
        return false
    }

    const valueFixedToString = value.toString()
    const checkScientificNotation = /^(?:([+-]?(?:\\d+\\.\\d*|\\.\\d+))|(\\\\[0-7]+)|([+-]?\\d+)|([+-]?(?:\\d+(?:\\.\\d*)?|\\.\\d+)[eE][+-]?\\d+))$/g
    const checkNumber = /[+-]?([0-9]*[.])?[0-9]+/g

    if (checkScientificNotation.test(valueFixedToString) || checkNumber.test(valueFixedToString)) {
        const pfdAsNumber = Number(valueFixedToString)

        // TODO: See if it's necessary to verify if pfd is greater than 1
        if (
            (minLimit !== false ? (minCloseInterval ? pfdAsNumber >= minLimit : pfdAsNumber > minLimit) : true) &&
            (maxLimit !== false ? (maxCloseInterval ? pfdAsNumber <= maxLimit : pfdAsNumber < maxLimit) : true)
        ) {
            return true
        }
    }

    return false
}
